<template>
  <div class="page-payment-methods">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'billing'}">Billing Central</router-link> /
          Payment Methods
        </h1>
      </div>

      <div class="header-actions">
        <router-link class="btn is-tertiary" :to="{name: 'add-payment-method'}"
          >Add New Card</router-link
        >
      </div>
    </PageHeader>

    <div class="page-columns" v-if="currentUser.owns_company">
      <div class="col main">
        <div>
          <Notification
            v-if="notification.active"
            :content="notification.content"
            :type="notification.type"
          />

          <div v-if="paymentMethodsLoaded">
            <div v-if="paymentMethods.length">
              <div
                v-for="card in paymentMethods"
                class="payment-card"
                :key="card.id"
              >
                <PaymentCard
                  :card="card"
                  :customer="customer"
                  showSetDefault
                  @setDefault="setDefault"
                />
              </div>
            </div>

            <div v-else>
              <p>You don't have any payment methods</p>
            </div>
          </div>

          <div v-else>
            <p>Loading Payment Methods...</p>
          </div>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Payment Methods</h1>
            <p>
              Here, you can manage your payment methods safely and securely. By
              default, all future invoices will attempt to charge the
              <strong>default card</strong>.
            </p>
            <p>
              If you have any questions regarding payment methods, our team
              would be happy to help. Simply use the
              <strong>Chat with us</strong> tab on your right.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view v-if="currentUser.owns_company" />
  </div>
</template>

<script>
import {mapState} from 'vuex'

import {readStripeCustomerData} from '@/lib/payments/customers'
import {
  readCustomerPaymentMethodsData,
  setDefaultCustomerPaymentMethod
} from '@/lib/payments/payment_methods'

import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import PaymentCard from '@/components/PaymentCard'

import page from '@/mixins/page'
import notification from '@/mixins/notification'

export default {
  name: 'payment-methods',

  data() {
    return {
      title: 'Payment Methods',
      paymentMethods: [],
      paymentMethodsLoaded: false,
      customer: {}
    }
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  components: {
    PageHeader,
    PageSummary,
    PaymentCard
  },

  computed: {
    ...mapState(['currentUser'])
  },

  methods: {
    getData() {
      readStripeCustomerData(this.companyId)
        .then(({data}) => {
          this.customer = data
        })
        .catch((response) => {
          alert(`Ooops! We couldn't seem to find you in our database. Please contact support and we'll see what's up!`)
        })

      readCustomerPaymentMethodsData(this.companyId)
        .then(({data}) => {
          this.paymentMethods = data.data
          this.paymentMethodsLoaded = true
        })
        .catch(({response}) => {})
    },

    setDefault(card) {
      let methodId = {
        payment_method_id: card.id
      }

      setDefaultCustomerPaymentMethod(this.companyId, methodId).then(() => {
        this.triggerNotification('success', 'default card', 'updated')

        window.setTimeout(() => {
          this.getData()
        }, this.closeDelay)
      })
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.page-payment-methods
  @extend %page
  position: relative

  .main
    padding: $gap-medium

    > div
      width: 100%
</style>
